<div style="display:flex; flex-direction: column">
    <label *ngIf="label"
        [ngStyle]="{'width': labelWidth + 'px', 'color': disabled ? 'rgba(0, 0, 0, 0.38)' : ''}">
        <span translate>{{label}}</span><span *ngIf="required" style="color:red;">*</span>
    </label>
    <mat-radio-group [disabled]="disabled"
        [labelPosition]="labelPosition"
        [name]="name"
        [required]="required"
        (change)="change.emit($event.value)"
        [(ngModel)]="selected"
        [ngStyle]="{
            'display': arrange != '' ? 'flex' : 'block',
            'flex-direction': arrange == 'vertical' ? 'column' : 'row',
            'align-items': arrange == 'horizontal' ? 'center' : 'stretch',
            'padding-left': label ? '15px' : ''
        }"
        [ngClass]="{'radioButtonError': isError}"
        style="flex-wrap: wrap;">
        <mat-radio-button *ngFor="let value of values; let i = index;"
            class="align-radio-button"
            [ngClass]="{'top-align': buttonAlignment == 'top', 'center-align': buttonAlignment == 'center', 'bottom-align': buttonAlignment == 'bottom'}"
            tabIndex="{{i == 0 ? tabIndex : -1}}"
            [value]="value"
            [id]="ids[i]"
            [disabled]="disabledValues.includes(value) || disabledIndexes.includes(i)"
            [ngStyle]="{
                'margin-bottom': arrange == 'vertical' && values.length != i + 1 ? spaceBetween : '0px',
                'margin-right': arrange != 'vertical' && values.length != i + 1 ? spaceBetween : '0px'
            }">
            <div *ngIf="labels.length <= i || labels[i]"
                [ngStyle]="{'white-space' : wordWrap ? 'normal' : 'inherit'}">
                <span *ngIf="!tylTranslate" translate>{{labels.length > i ? labels[i] : value}}</span>
                <span *ngIf="tylTranslate" translate>{{labels.length > i ? (labels[i] | tylTranslate) : (value | tylTranslate)}}</span>
            </div>
            <ng-container *ngTemplateOutlet="contentTemplate; context: {'value': value};"></ng-container>
        </mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="isError">{{errorMessage}}</mat-error>
</div>
